import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Published = ({renderChevronContainer, articlesPath, initialData, isParent}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const expandParam = searchParams.get('expand');
  
  const [expanded, setExpanded] = useState(expandParam === 'published');
  const [tableData, setTableData] = useState(false);
  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      if (expandParam === 'published') {
        fetchData();
      }
      return;
    }
    fetchData();
  }, [expanded])

  const setColumns = () => {
    if(isParent) {
      return [
        {width: '160px'},
        null,
        {width: '160px'},
        {width: '160px'},
        null,
        {width: '30px'},
        {width: '30px'},
        {width: '30px'},
        {width: '30px'},
        {width: '30px'},
        {width: '30px'}
      ]
    } else {
      return [
        {width: '160px'},
        null,
        {width: '160px'},
        null,
        {width: '30px'},
        {width: '30px'},
        {width: '30px'},
        {width: '30px'},
        {width: '30px'},
        {width: '30px'}
      ]
    }
  }

  const mapColumns = (dt, row) => {
    if(isParent) {
      return (
        dt.fnAddData( [
          row.published_at,
          row.sort_column,
          row.channel_name,
          row.submitting_author,
          row.title,
          row.article_type,
          row.siq,
          row.scorings_count,
          row.views_count,
          row.downloads_count,
          row.citations_count,
      ], false)
      )
    } else {
      return (
        dt.fnAddData( [
          row.published_at,
          row.sort_column,
          row.submitting_author,
          row.title,
          row.article_type,
          row.siq,
          row.scorings_count,
          row.views_count,
          row.downloads_count,
          row.citations_count,
      ], false)
      )
    }
  }

  const populateTable = (fetchedTableData) => {
    var dt = $("#published-table").DataTable({
      columns: setColumns(),
      columnDefs: [
        {targets: [0], orderData: [1]},
        {targets: [1], visible: false}
      ],
      dom: '<"row"<"large-5 columns"f>>tr<"row"<"large-8 columns pagination-details" <"pull-left"p><"pull-left showing-info"i>><"large-4 columns table-length-container"<"text-right"l>>>',
      "fnDrawCallback": function(oSettings) {
        if (oSettings.fnRecordsDisplay() == 0) {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
          $(oSettings.nTableWrapper).find('.dataTables_length').hide();
          $(oSettings.nTableWrapper).find('.dataTables_info').hide();
        } else if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        } else {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
          $(oSettings.nTableWrapper).find('.dataTables_length').show();
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        }
      },
    })
    
    dt.api().clear();
    for (var i = 0; i < fetchedTableData.articles.length; i++) {
      let row = fetchedTableData.articles[i];
      mapColumns(dt, row)
    }
    dt.fnSort([[1, 'desc']])
    dt.fnDraw()
    $(document).foundation('reflow');
  }

  const fetchData = () => {
    if(tableData) {
      populateTable(tableData)
      return;
    }

    $.ajax({
      type: 'GET',
      url: articlesPath,
      data: {state: 'Published'},
      success: function(data) {
        setTableData(data)
        populateTable(data)
      }
    });
  }

  const renderHeaderRow = () => {
    return (
      <div className="row article-state-row">
        <div className="small-1 columns bubble-container has-tip tip-top" data-tooltip="" id="bubble-tooltip-editor-preview" title={initialData.tooltip}>
          <img src={`https://public.cureus.com/channel-icons/grey-bubble.png`} />
          <span className="bubble-text">{initialData.total}</span>
        </div>
        <div className="small-9 columns article-state-label">
          <h4>{initialData.label}</h4>  
          <span>{initialData.blurb}</span>
        </div>
        <div className="small-1 columns chevron-container">
          {renderChevronContainer(expanded, setExpanded)}
        </div>
      </div>
    )
  }

  const renderChannel = () => {
    if(isParent) {
      return <th>Channel</th>
    }
  }

  return (
    <React.Fragment>
      <div className="article-state-row-container">
        {renderHeaderRow()}
        {expanded && 
          <div className="channel-articles-datatable-container">
            <table id="published-table">
              <thead>
                <tr>
                  <th>Publication date</th>
                  <th></th>
                  {renderChannel()}
                  <th>Submitting author</th>
                  <th>Title</th>
                  <th>Article type</th>
                  <th>SIQ score</th>
                  <th>SIQ count</th>
                  <th>Views</th>
                  <th>Downloads</th>
                  <th>Citations</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        }        
      </div>

    </React.Fragment>
  )
}

export default Published;